// TODO how does this match up with BE responses and requests
export class Tag {
    readonly tagName: string;
    readonly tagId: number;
    readonly tagTypeId: number;
    readonly tagTypeName: string;

    public isIn = (arr: { tagId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.tagId === this.tagId) >= 0;
    };

    public constructor(
        tagId: number,
        tagName: string,
        tagTypeId: number,
        tagTypeName: string
    ) {
        this.tagId = tagId;
        this.tagName = tagName;
        this.tagTypeId = tagTypeId;
        this.tagTypeName = tagTypeName;
    }

    public static WillingToTravel = new Tag(
        1330,
        "Willing to travel",
        130,
        "Travel"
    );

    public static WillingToRelocateYes = new Tag(
        1601,
        "Willing to relocate - yes",
        130,
        "Travel"
    );

    public static WillingToRelocateNo = new Tag(
        1602,
        "Willing to relocate - no",
        130,
        "Travel"
    );

    public static RelocationAssistanceNeeded = new Tag(
        1329,
        "Relocation assistance needed",
        80,
        "Benefits"
    );

    public static MondayMornings = new Tag(
        1582,
        "Monday mornings",
        110,
        "Contact Preference"
    );

    public static MondayAfternoons = new Tag(
        1583,
        "Monday afternoons",
        110,
        "Contact Preference"
    );

    public static MondayEvenings = new Tag(
        1584,
        "Monday evenings",
        110,
        "Contact Preference"
    );

    public static TuesdayMornings = new Tag(
        1585,
        "Tuesday mornings",
        110,
        "Contact Preference"
    );

    public static TuesdayAfternoons = new Tag(
        1586,
        "Tuesday afternoons",
        110,
        "Contact Preference"
    );

    public static TuesdayEvenings = new Tag(
        1587,
        "Tuesday evenings",
        110,
        "Contact Preference"
    );

    public static WednesdayMornings = new Tag(
        1588,
        "Wednesday mornings",
        110,
        "Contact Preference"
    );

    public static WednesdayAfternoons = new Tag(
        1589,
        "Wednesday afternoons",
        110,
        "Contact Preference"
    );

    public static WednesdayEvenings = new Tag(
        1590,
        "Wednesday evenings",
        110,
        "Contact Preference"
    );

    public static ThursdayMornings = new Tag(
        1591,
        "Thursday mornings",
        110,
        "Contact Preference"
    );

    public static ThursdayAfternoons = new Tag(
        1592,
        "Thursday afternoons",
        110,
        "Contact Preference"
    );

    public static ThursdayEvenings = new Tag(
        1593,
        "Thursday evenings",
        110,
        "Contact Preference"
    );

    public static FridayMornings = new Tag(
        1594,
        "Friday mornings",
        110,
        "Contact Preference"
    );

    public static FridayAfternoons = new Tag(
        1595,
        "Friday afternoons",
        110,
        "Contact Preference"
    );

    public static FridayEvenings = new Tag(
        1596,
        "Friday evenings",
        110,
        "Contact Preference"
    );

    public static NoticeAvailabilityASAP = new Tag(
        1597,
        "ASAP",
        140,
        "Notice Availability"
    );

    public static NoticeAvailabilityOneWeek = new Tag(
        1598,
        "1 week notice",
        140,
        "Notice Availability"
    );

    public static NoticeAvailabilityTwoWeeks = new Tag(
        1599,
        "2 weeks notice",
        140,
        "Notice Availability"
    );

    public static NoticeAvailabilityOneMonthPlus = new Tag(
        1600,
        "1 month+ notice",
        140,
        "Notice Availability"
    );

    public static Submitted = new Tag(1618, "Submitted", 160, "Status History");

    public static Interviewed = new Tag(
        1619,
        "Interviewed",
        160,
        "Status History"
    );

    public static Offered = new Tag(1620, "Offered", 160, "Status History");

    public static Hired = new Tag(1621, "Hired", 160, "Status History");

    public static HighSchoolGED = new Tag(2692, "High School/GED", 200, "Education");
    public static Associate = new Tag(2693, "Associate degree or higher", 200, "Education");
    public static Bachelors = new Tag(2694, "Bachelor's degree or higher", 200, "Education");
    public static Masters = new Tag(2695, "Master's degree or higher", 200, "Education");
    public static Doctorate = new Tag(2696, "Doctorate", 200, "Education");

    public static asArray = () => [
        Tag.WillingToTravel,
        Tag.WillingToRelocateYes,
        Tag.WillingToRelocateNo,
        Tag.RelocationAssistanceNeeded,
        Tag.MondayMornings,
        Tag.MondayAfternoons,
        Tag.MondayEvenings,
        Tag.TuesdayMornings,
        Tag.TuesdayAfternoons,
        Tag.TuesdayEvenings,
        Tag.WednesdayMornings,
        Tag.WednesdayAfternoons,
        Tag.WednesdayEvenings,
        Tag.ThursdayMornings,
        Tag.ThursdayAfternoons,
        Tag.ThursdayEvenings,
        Tag.FridayMornings,
        Tag.FridayAfternoons,
        Tag.FridayEvenings,
        Tag.NoticeAvailabilityASAP,
        Tag.NoticeAvailabilityOneWeek,
        Tag.NoticeAvailabilityTwoWeeks,
        Tag.NoticeAvailabilityOneMonthPlus,
        Tag.Submitted,
        Tag.Interviewed,
        Tag.Offered,
        Tag.Hired,
        Tag.HighSchoolGED,
        Tag.Associate,
        Tag.Bachelors,
        Tag.Masters,
        Tag.Doctorate,
    ];

    public static fromId = (id: number) =>
        Tag.asArray().find(t => t.tagId === id);
}
